import { ModelRegistryService as BaseModelRegistryService } from '@core/shared/model';
import { ConfigService } from '@core/shared/config';
import { Store } from '@ngxs/store';
import { DevToolsRegistry } from '../dev-tools';
import * as i0 from "@angular/core";
import * as i1 from "../dev-tools";
import * as i2 from "@core/shared/config";
import * as i3 from "@ngxs/store";
export let ModelRegistryService = /*#__PURE__*/(() => {
  class ModelRegistryService extends BaseModelRegistryService {
    constructor(debug, config, store) {
      super();
      this.store = store;
      debug.exposeDebugFunction(['Model', 'Registered Item Models'], () => {
        return this.getItemModels();
      });
    }
    static {
      this.ɵfac = function ModelRegistryService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModelRegistryService)(i0.ɵɵinject(i1.DevToolsRegistry), i0.ɵɵinject(i2.ConfigService), i0.ɵɵinject(i3.Store));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: ModelRegistryService,
        factory: ModelRegistryService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ModelRegistryService;
})();